// extracted by mini-css-extract-plugin
export var pageCrossBackground = "layout-module--pageCrossBackground--A7oI6";
export var pageCrossLogo = "layout-module--pageCrossLogo--Z1eHe";
export var pageCrossWrapper = "layout-module--pageCrossWrapper--48HTR";